import { useEffect, useState } from 'react';
import { api, type IngestionRun } from '../api';

export function IngestionPage() {
  const [runs, setRuns] = useState<IngestionRun[]>([]);
  const [busy, setBusy] = useState(false);

  function refresh() {
    api.ingestionRuns().then((d) => setRuns(d.runs));
  }
  useEffect(refresh, []);

  async function manualRun() {
    setBusy(true);
    try {
      await api.ingestionRun();
    } finally {
      setBusy(false);
      refresh();
    }
  }

  return (
    <div className="card">
      <h2>
        Mailbox ingestion
        <button onClick={manualRun} disabled={busy} style={{ marginLeft: 'auto' }}>
          {busy ? 'Running…' : 'Run now'}
        </button>
      </h2>
      {runs.length === 0 ? (
        <p className="muted">No runs yet.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Started</th><th>Status</th><th>Seen</th><th>Imported</th><th>Skipped</th><th>Error</th>
            </tr>
          </thead>
          <tbody>
            {runs.map((r) => (
              <tr key={r.id}>
                <td className="muted">{new Date(r.started_at).toLocaleString()}</td>
                <td>
                  <span className={`badge ${r.status === 'completed' ? 'pass' : r.status === 'failed' ? 'fail' : 'warning'}`}>
                    {r.status}
                  </span>
                </td>
                <td>{r.messages_seen}</td>
                <td>{r.messages_imported}</td>
                <td>{r.messages_skipped}</td>
                <td className="muted">{r.error ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
